<template>
    <div id="conva"> </div>
</template>

<script>
    import Konva from 'konva'
    import {navigate} from '@/nodes.js'
    export default {
        data: function () {
            return {
                mapWidth: 800,
                mapHeight: 1000,
            }
        },
        props: ['startpoint', 'endpoint', 'nodes'],
        created() {
            // load
            // if (localStorage.getItem("nodes")){
            //     this.nodes = JSON.parse(localStorage.getItem("nodes"));
            // }
        },
        mounted(){
          this.route()
        },
        methods: {
            route: function(){
                let graf = {};
                let start = this.nodes.find(x=>x.id == this.startpoint);
                let v = this;
                let dest = this.endpoint;
                this.nodes.forEach(function (el) {
                    graf[el.id] = el.children
                });

                let routes = navigate(this.startpoint);

                if (!routes[dest]){
                    console.log('count not find route ' + this.startpoint + ' to ' + this.endpoint)
                    console.log(routes)
                    return false;
                }

                var stage = new Konva.Stage({
                    container: 'conva',
                    width: 800 ,
                    height: 1000
                });

                var text = new Konva.Layer();

                let points = [start.x, start.y];
                routes[dest].forEach(function (el) {
                    let node = v.getNode(el);
                    points.push(node.x)
                    points.push(node.y)
                })

                var nacigationLine = new Konva.Line({
                    points: points,
                    stroke: 'black',
                    strokeWidth: 5,
                    lineCap: 'round',
                    lineJoin: 'round',
                    dash: [1,12],
                });

                text.add(nacigationLine);
                // add the layer to the stage
                stage.add(text);
                // draw the image

                var anim = new Konva.Tween({
                    node: nacigationLine,
                    dashOffset: -12,
                    repeat: -1,
                    duration: 1,
                    onFinish: () => anim.reset().play()
                })

                anim.play();
                text.draw();

            },

            getNode: function (node) {
                return this.nodes.find(x=>x.id==node)
            }
        },
        computed: {

        },
        watch : {
            startpoint: function (newval, oldval) {
                console.log('startchanged');
                this.route()
            }
        }
    }
</script>

<style scoped lang="scss">
    #conva {
        position: absolute;
        top: 0;
        left: 0;
    }
</style>